/**
 * This class will aid in tracking the user's selection/context for device listing
 * The User in the Device Listing page can do the following:
 * - All Account Devices ( ref: account)
 * - select a group ( and move back to AllAccount by clicking on breadCrumb-Devices)
 * - Select a category ( and move back by clicking on Bread Crumb - Devices )
 * - Select a savedFilter from Side Column ( and move back - Devices)
 * - select a savedFilter from HeaderBar ( and move back - Devices)
 * - Type a query on the header search bar (Search Bar Query) ( and move back by clearing the search)
 * 
 * Search Bar Query can have be in full account or withing a Tag or within Group ( if they have been selected)
 * Detailed scenarios/rules mentioned in ICP-3380
 * Summary of the rules:
 * - Context selected : The latest context will apply (group followed by tag will have tags as context)
 * - Search in Header - If group, Tag or account will be retained
 * - Search in header - if saved filter, the filter selection will be cleared by filter query will be retained
 * 
 * APIs:
 * - groupSelected()
 * - tagSelected()
 * - savedFilterSelected()
 * - accountSelected() ( will also be initial state)
 * - applySearchCriteria()
 * 
 * 
 */

import { convertSearchObjsToQueryString } from "./Helpers/filterQuery-helpers"


class DeviceListingContext {
  context: string
  contextData: any
  searchCriteria: any[]

  constructor() {
    this.context = 'account' // group, tag, savedFilter
    this.contextData = undefined
    this.searchCriteria = []
  }

  // this will have to get refactored
  private selectContext(context: string, contextData: any) {
    const clone = this.clone()
    clone.context = context
    clone.contextData = contextData
    clone.searchCriteria = []

    if (context === 'savedFilter'){
      clone.searchCriteria = contextData.conditions
    }
    return clone
  }

  private clone() {
    return Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this))
  }

  groupSelected(group: any): DeviceListingContext {
    return this.selectContext('group', group)
  }

  tagSelected(tag: any): DeviceListingContext {
    return this.selectContext('tag', tag)
  }

  savedFilterSelected(savedFilter: any) {
    return this.selectContext('savedFilter', savedFilter)
  }

  accountSelected() {
    return this.selectContext('account', undefined)
  }

  applySearchCriteria(searchCriteria: any[]) {
    const clone = this.clone()
    if (clone.context === 'savedFilter') {
      clone.context = 'account'
      clone.contextData = undefined
    }
    clone.searchCriteria = searchCriteria
    return clone
  }

  /**
   * helpers
   * @returns 
   */

  getListingContext(): { groupId?: string, tagId?: string , queryString: string}{
    let groupId, tagId, queryString = ''

    if (this.searchCriteria && this.searchCriteria.length)
      queryString = convertSearchObjsToQueryString(this.searchCriteria)

    if (this.context === 'group')
      groupId = this.contextData.id

    if (this.context === 'tag')  
      tagId = this.contextData.catId

    if (this.context === 'savedFilter'){
      // For savedFilter we will send from the conditions even if the search criteria
      // if populated as this will give us upcation fo failure faster
      queryString = convertSearchObjsToQueryString(this.contextData.conditions)
    }

    return { groupId, tagId, queryString }
  }

  isGroupContext(): boolean { return this.context === 'group'}
  isTagContext(): boolean { return this.context === 'tag'}
  isSavedFilterContext(): boolean { return this.context === 'savedFilter'}


}

export { DeviceListingContext }